import React from "react";
import MainLaundryTable from "components/Tables/MainLaundry/MainLaundryTable";
import PlanTable from "components/Tables/plan/PlanTable";
import PaymentTable from "components/Tables/Payments/PaymentTable";
import OrderTable from "components/Tables/Orders/OrderTable";

const ListOrder = () => {
  return (
    <div>
      <OrderTable />
    </div>
  );
};

export default ListOrder;
